import { IDateObject } from 'src/app/analyses/interfaces/analyses.types';
import {
  NgbDateNativeUTCAdapter,
  NgbDateStruct,
} from '@ng-bootstrap/ng-bootstrap';

export function subtractCurrentDateYear(years: number): Date {
  const date = new Date();
  date.setFullYear(date.getFullYear() - years);
  return date;
}

export function objectToDate(obj: IDateObject): Date {
  const dateNow = new Date();
  return new Date(
    obj.year ? obj.year : dateNow.getFullYear(),
    obj.month ? obj.month - 1 : dateNow.getMonth(),
    obj.day ? obj.day : dateNow.getDate(),
    obj.hours ? obj.hours : dateNow.getHours(),
    obj.minutes ? obj.minutes : dateNow.getMinutes(),
    obj.seconds ? obj.seconds : dateNow.getSeconds(),
    obj.milliseconds ? obj.milliseconds : dateNow.getMilliseconds()
  );
}

export const ngbDateFromISO = (iso: string): NgbDateStruct => {
  return ngbDateFromDate(new Date(iso));
};

export const ngbDateFromDate = (date: Date): NgbDateStruct => {
  return new NgbDateNativeUTCAdapter().fromModel(date);
};

export const ngbDateToISO = (value: NgbDateStruct): string => {
  return new NgbDateNativeUTCAdapter().toModel(value).toISOString();
};

export const ngbDateToISOWithTime = (value: NgbDateStruct): string => {
  return new NgbDateNativeUTCAdapter().toModel(value).toISOString();
};

// Converts ngb date to native JS date and adds current time
export const ngbDateToNativeUTCDateTime = (date: NgbDateStruct): Date => {
  const now = new Date();
  const jsDate = new Date(
    Date.UTC(
      date.year,
      date.month - 1,
      date.day,
      now.getUTCHours(),
      now.getUTCMinutes(),
      now.getUTCSeconds(),
      now.getUTCMilliseconds()
    )
  );
  // avoid 30 -> 1930 conversion
  jsDate.setUTCFullYear(date.year);
  return jsDate;
};
